(function () {
  document.addEventListener('click', function (e) {
    const expandBtn = e.target.closest('.octo-expand-all');
    const collapseBtn = e.target.closest('.octo-collapse-all');
    if (!expandBtn && !collapseBtn) return;

    const root = e.target.closest('#octo-tutorials');
    if (!root) return;

    const accordions = Array.from(root.querySelectorAll('details.tutorials-accordion'));
    if (!accordions.length) return;

    if (expandBtn) {
      accordions.forEach(d => d.open = true);
    }

    if (collapseBtn) {
      accordions.forEach(d => d.open = false);
    }
  }, true);
})();
